module.exports = __webpack_public_path__ + "img/41.5f667600.jpg";